
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class HeaderUserPanel extends Vue {
  @Prop() dataSource: {
    follow: number
    followed: number
    like: number
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  copyUserId() {
    const disappear = 'position: fixed;z-index: -2;top: -100px'
    let input = document.createElement('input')
    input.value = this.UserInfo.userName
    input.setAttribute('style', disappear)
    document.body.appendChild(input)
    input.focus()
    input.select()
    if (document.execCommand('copy', false, undefined)) {
      //success info
      this.$msg('复制成功', 'success')
    } else {
      this.$msg('请手动复制ID号')
    }
    document.body.removeChild(input)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
